<template>
    <footer class="pb-5">
        <div class="d-flex flex-column flex-lg-row align-items-center justify-content-lg-between px-4 py-5">
            <div>
                <p class="mb-0 p-sm">
                    &copy; My Online Estate Agent Ltd 2018, All rights reserved
                </p>
            </div>
            <div>
                <nav>
                    <ul v-if="navigation">
                        <li
                            v-for="item in navigation"
                            :key="item.id"
                        >
                            <router-link :to="{ name: item.name }">
                                {{ item.title }}
                            </router-link>
                        </li>
                    </ul>
                </nav>
            </div>
        </div>
    </footer>
</template>

<script>
export default {
    name: 'Footer',
    data() {
        return {
            navigation: [
                {
                    id: 1,
                    title: 'Privacy Policy',
                    name: 'privacy-policy'
                },
                {
                    id: 2,
                    title: 'Terms & Conditions',
                    name: 'terms-conditions'
                },
                {
                    id: 3,
                    title: 'Cookie Policy',
                    name: 'cookie-policy'
                }
            ]
        };
    }
};
</script>

<style lang="scss">
.footer {
    background: white;
    text-align: center;

    @include media-breakpoint-up(sm) {
        text-align: left;
    }

    nav {
        ul {
            list-style-type: none;
            display: flex;
            flex-direction: column;
            align-items: center;
            margin-bottom: 0;
            padding-left: 0;
            margin-top: 1.5rem;

            @include media-breakpoint-up(sm) {
                flex-direction: row;
            }

            @include media-breakpoint-up(lg) {
                margin-top: 0;
            }

            li {
                a {
                    color: theme-color('mid-grey');
                    @include font-size(1.2rem);
                }

                &:last-child {
                    &::after {
                        display: none;
                    }
                }

                @include media-breakpoint-up(sm) {
                    &::after {
                        content: "|";
                        margin: 0 1rem;
                    }
                }
            }
        }
    }
}
</style>
